
import { Button, Col, Form, Row, Spin, Table, Tabs } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPageSize } from '../utils/paging';
import styles from '../organization/organization.css';
import { editSbtTemplate, fetchSbtTemplates, fetchNewsletterTemplates, onChangeTab, editNewsletterTemplate } from './templateActions';
import SbtTemplateModalComponent from './sbtTemplateModalComponent';
import NewsletterTemplateModalComponent from './newsletterTemplateModalComponent';

const { Column } = Table;
const TabPane = Tabs.TabPane

class SbtTemplateComponent extends Component {

  componentDidMount() {
    if (this.props.sbtTemplates.length === 0) {
      this.props.dispatch(fetchSbtTemplates());
      this.props.dispatch(fetchNewsletterTemplates());
    }
  }

  newTemplate = () => {

    if (this.props.activeTab === '1') {
      let template = { id: -1 };
      this.props.dispatch(editSbtTemplate(template));
    }
    else if (this.props.activeTab === '2') {
      let template = { id: -1 };
      this.props.dispatch(editNewsletterTemplate(template));
    }
  }

  render() {
    let data = this.props.sbtTemplates || [];
    const onSbtRow = (edit) => ({
      onClick: () => {
        let clone = Object.assign({}, edit)
        this.props.dispatch(editSbtTemplate(clone));
      }
    });

    const onNewsletterRow = (edit) => ({
      onClick: () => {
        let clone = Object.assign({}, edit)
        this.props.dispatch(editNewsletterTemplate(clone));
      }
    });

    return (<div>

      <SbtTemplateModalComponent />
      <NewsletterTemplateModalComponent />

      <Button icon='plus' type='primary' style={{ zIndex: 10000, position: 'absolute', right: 30 }} size='large' onClick={() => this.newTemplate()} >Skapa ny</Button>

      <Row>
        <Spin spinning={this.props.loading}>
          <Col span={24}>

            <Tabs activeKey={this.props.activeTab} onChange={(activeTab) => this.props.dispatch(onChangeTab(activeTab))} >
              <TabPane tab="Rättsfall" key={'1'}>

                <Table dataSource={data} size='small' pagination={{ pageSize: getPageSize(), position: 'bottom' }} onRow={onSbtRow} style={styles.table} >
                  <Column title="Mall" defaultSortOrder='ascend' width={250} dataIndex="name" key="name" />
                  <Column title="Filnamn" dataIndex="originalFileName" key="originalFileName" />
                  <Column title="Källa" dataIndex="sourceId" key="sourceId" />
                  <Column title="Beslutsdatum" dataIndex="decisionDateString" key="decisionDateString" />
                  <Column title="Publikation" dataIndex="documentSource" key="documentSource" />
                </Table>

              </TabPane>
              <TabPane tab="Nyhetsbrev" key={'2'}>

                <Table dataSource={this.props.newsletterTemplates} size='small' pagination={{ pageSize: getPageSize(), position: 'bottom' }} onRow={onNewsletterRow} style={styles.table} >                  
                  <Column title="Namn" dataIndex="title" key="title" />
                  <Column title="Databaser" dataIndex="dbType" key="dbType" />
                </Table>

              </TabPane>
            </Tabs>
          </Col>
        </Spin>
      </Row>

    </div>)
  }
}

const mapStateToProps = (state) => {
  return {
    newsletterTemplates: state.templates.newsletterTemplates,
    sbtTemplates: state.templates.sbtTemplates,
    activeTab: state.templates.activeTab,
    loading: state.templates.loading
  }
};

export default connect(mapStateToProps)(Form.create()(SbtTemplateComponent));


// WEBPACK FOOTER //
// ./src/templates/templateComponent.js